module.exports = __webpack_public_path__ + "fonts/Mukta-800-latin-ext20.3f10329.woff2";